module.exports = __webpack_public_path__ + "static/media/PM133.6aeb1bb9.png";